import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './header.component';
import {RouterModule} from '@angular/router';
import {HeaderActionComponent} from './header-action/header-action.component';
import {TuiSvgModule} from '@taiga-ui/core/components/svg';
import {TuiToggleModule} from '@taiga-ui/kit/components/toggle';
import {FormsModule} from '@angular/forms';
import {TuiButtonModule} from '@taiga-ui/core/components/button';
import {TuiExpandModule} from '@taiga-ui/core';
import {TuiAvatarModule} from '@taiga-ui/kit';
import {TuiLetModule} from '@taiga-ui/cdk';
import {CoreModule} from '@core/core.module';
import {LanguagePickerModule} from '@ui/language-picker/language-picker.module';
import {ImageVariantModule} from '@tisa-group/core';

@NgModule({
  declarations: [HeaderComponent, HeaderActionComponent],
  exports: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    TuiSvgModule,
    TuiButtonModule,
    TuiToggleModule,
    FormsModule,
    TuiLetModule,
    TuiExpandModule,
    TuiAvatarModule,
    CoreModule,
    LanguagePickerModule,
    ImageVariantModule,
  ],
})
export class HeaderModule {}
